import React, { Component } from 'react';
import styled from 'styled-components';
import {ScreenSize} from "../constants/screensize";
import {ImageBaseURL} from "../constants/server";

const Container = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-around;
	align-items: center;
	border-bottom: 1px solid gray;
	flex-direction: row;
	background: white;
	
	@media (max-width: ${ScreenSize.phone}px) {
		flex-direction: column;
	}
`;

const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const HeaderLabel = styled.div`
	font-size: 28px;
	font-weight: 800;
	margin-block-start: 0.67em;
	margin-block-end: 0.67em;
	
	@media (max-width: ${ScreenSize.tablet}px) {
		font-size: 18px;
	}
`;

const Link = styled.a`
	position: absolute;
	max-width: 50px; 
	left: 50px;
	
	@media (max-width: ${ScreenSize.phone}px) {
		position: inherit;
	}
`;

const Logo = styled.img`
	width: 100%;
`;

export default class WelcomeHeader extends Component {
	render() {
		return (
			<Container>
				<Link href="https://seasonalsetter.com?utm_source=ordersiteheader"><Logo src={ImageBaseURL + '/logo.png'} /></Link>
				<TextContainer>
					<HeaderLabel>
						{this.props.children}
					</HeaderLabel>
				</TextContainer>
			</Container>
		);
	}
}
